import { render, staticRenderFns } from "./nuevoDocumento.vue?vue&type=template&id=4d6e6ab2"
import script from "./nuevoDocumento.vue?vue&type=script&lang=js"
export * from "./nuevoDocumento.vue?vue&type=script&lang=js"
import style0 from "./nuevoDocumento.vue?vue&type=style&index=0&id=4d6e6ab2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports